export function urgencyFormula(durationInDays: number) {
  return durationInDays >= 0
    ? Math.round(
        Math.max(0, Math.min(100, 100 - 17 * Math.sqrt(durationInDays))),
      )
    : 100; // If overdue, urgency is 100
}
